module.exports = __webpack_public_path__ + "media/assets/images/blog/TESTA-LINKEDIN-3.jpg-small-15e088007a61e9b18727ec11505c299b.png";